// extracted by mini-css-extract-plugin
export default {"addCardModal":"AddCard_addCardModal__gx7oJ","closeModal":"AddCard_closeModal__EGZ5K","header":"AddCard_header__9xHUl"};